import React from "react";
import { FormGroup, FormField, Icon } from "semantic-ui-react";

// Serializer
import CheckupReportSerializer from "issara-sdk/types/CheckupReportSerializer_core";

// Common
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";

// Utils
import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";

// Interface
import { SetProp, PickedState, ActionReport, BTN_ACTS } from "./sequence/HealthRecommendation";

type RenderHealthRecommendationActionButtonProps = {
  // func
  setProp: SetProp;
  onPrintReport: () => void;
  onSaveReport: (saveAction: ActionReport) => void;
  // data
  checkupReportData: CheckupReportSerializer;
} & Pick<PickedState, "buttonLoadCheck">;

const RenderHealthRecommendationActionButton = (
  props: RenderHealthRecommendationActionButtonProps
) => {
  const { setProp, onPrintReport, onSaveReport, buttonLoadCheck, checkupReportData } = props;
  const formatDateTime =
    formatISOtoBEDateTime(checkupReportData?.approved_at)?.dateTimeShortBracket || "";
  const isDisabled = !checkupReportData?.id;
  const isApproved = !!checkupReportData?.approved;

  return (
    <>
      <FormGroup>
        <FormField
          style={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "0.5rem" }}
        >
          <div style={{ flex: 1 }}>
            <ButtonLoadCheck
              // func
              setProp={setProp}
              onClick={onPrintReport}
              // data
              paramKey={BTN_ACTS.PRINT_REPORT}
              buttonLoadCheck={buttonLoadCheck?.[BTN_ACTS.PRINT_REPORT]}
              // config
              color="yellow"
              size="tiny"
              title={
                <>
                  <Icon name="print" />
                  <label>Print</label>
                </>
              }
              style={{ width: "100%" }}
              disabled={isDisabled}
            />
          </div>
          <div style={{ flex: 1 }}>
            <ButtonLoadCheck
              // func
              setProp={setProp}
              onClick={() => console.log("Send Mobile is not available yet")}
              // data
              paramKey={BTN_ACTS.SEND_MOBILE}
              buttonLoadCheck={buttonLoadCheck?.[BTN_ACTS.SEND_MOBILE]}
              // config
              color="purple"
              size="tiny"
              title={
                <>
                  <Icon name="mobile alternate" />
                  <label>Send</label>
                </>
              }
              style={{ width: "100%" }}
              disabled={isDisabled}
            />
          </div>
          <div style={{ display: isApproved ? "none" : "", flex: 1 }}>
            <ButtonLoadCheck
              // func
              setProp={setProp}
              onClick={() => onSaveReport("SAVE")}
              // data
              paramKey={`${BTN_ACTS.SAVE_REPORT}_SAVE`}
              buttonLoadCheck={buttonLoadCheck?.[`${BTN_ACTS.SAVE_REPORT}_SAVE`]}
              // config
              color="green"
              size="tiny"
              title="Save"
              style={{ width: "100%" }}
              disabled={isDisabled}
            />
          </div>
          <div style={{ flex: 1 }}>
            <ButtonLoadCheck
              // func
              setProp={setProp}
              onClick={() => onSaveReport(isApproved ? "UNAPPROVE" : "APPROVE")}
              // data
              paramKey={`${BTN_ACTS.SAVE_REPORT}_${isApproved ? "UNAPPROVE" : "APPROVE"}`}
              buttonLoadCheck={
                buttonLoadCheck?.[`${BTN_ACTS.SAVE_REPORT}_${isApproved ? "UNAPPROVE" : "APPROVE"}`]
              }
              // config
              color={isApproved ? "red" : "blue"}
              size="tiny"
              title={isApproved ? "Unapprove" : "Save & Approve"}
              style={{ width: "100%" }}
              disabled={isDisabled}
            />
          </div>
        </FormField>
      </FormGroup>
      {checkupReportData?.approved ? (
        <FormGroup>
          <FormField>
            <label
              style={{ fontStyle: "italic" }}
            >{`Approved by: ${checkupReportData?.approved_by_name} ${formatDateTime}`}</label>
          </FormField>
        </FormGroup>
      ) : null}
    </>
  );
};

export default React.memo(RenderHealthRecommendationActionButton);
